//@ts-ignore
import DateRangePicker from 'vanillajs-datepicker/DateRangePicker';
import 'vanillajs-datepicker/css/datepicker.css';
import {expose} from "@/ts/utilities";


//Module to iniatilize a datepicker, using library;
export module Datepicker {

    export function init($target : any = null){
        if($target){
            const datepicker = new DateRangePicker($target, {
                format: 'yyyy',
                autohide: true,
                pickLevel: 2,
            });
        }else{
            const $filters = document.querySelector('.filters');

            if($filters) {
                const $datePikers = document.querySelectorAll('div[id="datepicker"]');

                $datePikers.forEach(($datePiker: any) => {
                    const datepicker = new DateRangePicker($datePiker, {
                        format: 'yyyy',
                        autohide: true,
                        pickLevel: 2,
                    });
                })
            }

        }
    }

    init();

    expose('_datePicker', init);
}
